module.exports = __webpack_public_path__ + "static/media/PORT EDI LOGO.1150960b.JPG";